import { render, staticRenderFns } from "./WalletCardTemperamentSelect.vue?vue&type=template&id=c163cf6c&scoped=true&"
import script from "./WalletCardTemperamentSelect.vue?vue&type=script&lang=js&"
export * from "./WalletCardTemperamentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c163cf6c",
  null
  
)

export default component.exports